import React from 'react';
import AuthWrapper1 from './AuthWrapper1';
import googleIcon from '../../assets/google_icon.png';
import linkedInIcon from '../../assets/linkedin_icon.png';
import appleIcon from '../../assets/apple_icon.png';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import CustomBackgroundComponent from '../../ui-components/CustomBackgroundComponent';
import BackrrLogoImage from '../../ui-components/BackrrLogoImage';
import { useTheme } from '@emotion/react';
import CustomInputField from '../../ui-components/CustomInputField';
import { Primary } from '../../ui-components/Buttons';
import { useNavigate } from 'react-router-dom';
import { LoginViaEmail } from '../../api';
import toast from 'react-hot-toast';
import CustomToast from '../../ui-components/CustomToast';
import Cookies from "js-cookie";
import { auth, provider, signInWithPopup, signInWithRedirect, signOut } from "../../firebase";
import * as jwt_decode from 'jwt-decode';
import LinkedinLogin from './LinkedinLogin';
import { useConfig } from '../../dynamic-configuration/configContext';
import { checkForDomain, navigateToMain, redirectTo, setTokenForAuthorization, setUserType } from 'utils/index';
import { useToast } from 'context/ToastContext';
import GoogleLogin from './GoogleLogin';

export const LOGIN_GRADIENT = "linear-gradient(135deg, #84aef8 0%, #7852f8 100%)";

// Rounded, hairline-bordered input to match the auth card design
export const INPUT_SX = {
  m: 0,
  "& .MuiFilledInput-root": {
    borderRadius: "10px",
    border: "1px solid #E4E7EC",
    backgroundColor: "#FFFFFF",
  },
  "& .MuiFilledInput-root.Mui-focused": {
    borderColor: "#101828",
  },
  "& .MuiFilledInput-input": {
    padding: "15px 16px",
  },
};

const AuthLogin = () => {
  const { addToast } = useToast();
  const { config } = useConfig()
  const theme = useTheme();
  const navigate = useNavigate();
  const currentIP = window.location.host;
  const currentLocation = window.location.pathname
  const [userData, setUserData] = React.useState(null);
  const [loginMethod, setLoginMethod] = React.useState("email");
  const { mutateAsync: loginViaEmailAsync, status: LoginViaEmailStatus, error: LoginViaEmailError, isLoading, data: loginViaEmailResponse } = LoginViaEmail();

  React.useEffect(() => {
    window.document.getElementsByTagName("body")[0].style.background = "#FFFDFA";
  }, [])

  const [emailValue, setEmailValue] = React.useState("");
  const [emailError, setEmailError] = React.useState(false);

  const handleLogin = () => {
    setLoginMethod("email");
    loginViaEmailAsync({
      "email": emailValue,
      "devices": {
        "device_token": `${Math.random() * 10}`,
        "device_type": "web"
      },
      "last_login_ip": `${currentIP}`,
      "auth_provider": "email"
    }, {
      onSuccess: (verifyResponse) => {
        Cookies.set("pathname", window.location?.pathname + window.location?.search);
        const response = verifyResponse?.data?.data;
        if (verifyResponse?.data?.statusCode !== 403) {
          Cookies.set("email", emailValue);
          Cookies.set("step", Number(response?.userData?.step))
          Cookies.get("email") && navigate("/verification");
        }
        else{
          setEmailError(true);
        }
      },
      onError: () => {
        setEmailError(true);
      }
    });
  };

  // React.useEffect(() => {
  //   const initAppleSignIn = () => {
  //     window.AppleID.auth.init({
  //       clientId: 'in.backrr.startup',
  //       scope: "name%20email",
  //       redirectURI: "https://startup.backrr.in",
  //       state: 'SignInUserAuthenticationRequest',
  //       usePopup: true
  //     });
  //   };

  //   if (window.AppleID) {
  //     initAppleSignIn();
  //   } else {
  //     const script = document.createElement('script');
  //     script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
  //     script.onload = initAppleSignIn;
  //     document.body.appendChild(script);
  //   }
  // }, []);

  // const handleSignIn = async () => {
  //   await window.AppleID.auth.signIn().then((res) => {
  //     const id_token = res.authorization.id_token;
  //     // console.log(res, "res")
  //     const user = jwt_decode.jwtDecode(id_token);
  //     // console.log(user, "user")
  //     setLoginMethod("appleid");
  //     loginViaEmailAsync({
  //       "email": user?.email,
  //       "devices": {
  //         "device_token": `${Math.random() * 10}`,
  //         "device_type": "web"
  //       },
  //       "last_login_ip": `${currentIP}`,
  //       "auth_provider": "appleid"
  //     }, {
  //       onSuccess: (response) => {
  //         setTokenForAuthorization(response?.userData?.token);
  //         Cookies.set("is_profile_complete", response?.is_profile_completed);
  //         if (response?.is_profile_completed == true) {
  //           Cookies.set("is_profile_complete", true)
  //           navigate("/startups");
  //         }
  //         else {
  //           Cookies.set("is_profile_complete", false)
  //           Cookies.set("step", Number(response?.userData?.step))
  //           navigate("/onboarding");
  //         }
  //       }
  //     });
  //   }).catch((error) => {
  //     console.error(error);
  //   });
  // };

  const handleSignInGoogle = async () => {
    setLoginMethod("google");
    await signOut(auth);
    await signInWithPopup(auth, provider)
      .then((result) => {
        // console.log(result, "result?.user");
        Cookies.set("email", result?.user?.email)
        Cookies.set("userDetails", JSON.stringify({ first_name: result?._tokenResponse?.firstName, last_name: result?._tokenResponse?.lastName, mobile_number: result?.user?.phoneNumber }))
        loginViaEmailAsync({
          "email": result?.user?.email,
          "devices": {
            "device_token": `${Math.random() * 10}`,
            "device_type": "web"
          },
          "last_login_ip": `${currentIP}`,
          "auth_provider": "google"
        }, {
          onSuccess: (verifyResponse) => {
            const response = verifyResponse?.data?.data;
            if (currentIP?.includes("localhost")) {
              if (response?.collaborator_data?.connected_id) {
                Cookies.set("X-ADMIN-ID", response?.collaborator_data?.connected_id);
              }
              response?.userData?.token && setTokenForAuthorization(response?.userData?.token);
              // response?.token && setUserType("investor");
            }
            // response?.token && setUserType("investor");
            // Session to be same for current users:
            if (response?.collaborator_data?.connected_id) {
              Cookies.set("X-ADMIN-ID", response?.collaborator_data?.connected_id, { domain: checkForDomain() });
            }
            // console.log(response?.token)
            response?.userData?.token && setTokenForAuthorization(response?.userData?.token, checkForDomain());
            // response?.token && setUserType("investor", { domain: checkForDomain() });

            if (response?.userData?.is_profile_completed == true) {
              // console.log(currentLocation,"path")
              Cookies.set("is_profile_complete", true)
              navigate(currentLocation !== "/login" && currentLocation !== "/verification" ? currentLocation : "/deal-flow");
            }
            else {
              Cookies.set("is_profile_complete", false)
              // navigate("/onboarding?page=" + Number(response?.step));
              navigate("/onboarding");
              // console.log(response, "response")
              Cookies.set("step", Number(response?.userData?.step))
            }
          }
        });
      })
      .catch((error) => {
        console.error('Error signing in:', error);
      });
  };

  const handleSubmit = () => {
    let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailPattern?.test(emailValue)) {
      handleLogin();
    }
    else {
      setEmailError(true);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography sx={{ fontSize: { xs: "1.75rem", sm: "2rem" }, fontWeight: 700, color: "#101828", textAlign: "center", lineHeight: 1.2 }}>
        For Admin
      </Typography>
      <Typography sx={{ color: "#667085", textAlign: "center", mt: 1, fontSize: "1rem" }}>
        Continue with Backrr Account
      </Typography>

      <Box sx={{ mt: { xs: 3, sm: 4 } }}>
        <CustomInputField
          value={emailValue}
          onKeyDown={(e) => { if (e.key === "Enter") { handleSubmit(); } }}
          onChange={(event) => {
            setEmailValue(String(event.target.value)?.toLowerCase()); setEmailError(false);
          }}
          hasError={emailError}
          errorMessage={config?.validationFields?.email?.invalidError}
          label={config?.validationFields?.email?.label || "Email"}
          labelStyle={{ textTransform: "none", color: "#344054", fontWeight: 500, fontSize: "0.875rem", marginBottom: "8px" }}
          fullWidth
          type="email"
          placeholder="Enter your email"
          sx={INPUT_SX}
        />
      </Box>

      <Primary
        disabled={isLoading && loginMethod === "email"}
        sx={{ mt: 3, fontSize: '1rem' }}
        fullWidth
        onClick={() => { handleSubmit(); }}
      >
        {isLoading && loginMethod === "email" ?
          <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.4rem'} />
          : "Continue with Email"}
      </Primary>

      <Box sx={{ display: "grid", gap: "1rem" }}>
          {/* <Grid position={'relative'}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <Divider sx={{ flex: 1 }} />
            <Typography sx={{ width: "2rem", textAlign: "center" }}>or</Typography>
            <Divider sx={{ flex: 1 }} />
          </Grid> */}
          {/* {config?.settings.googleLogin && <WHITEBG sx={{ border: `1px solid ${theme.palette.customColors.g75}`, height: '55px' }} onClick={() => handleSignInGoogle()} fullWidth>
            {isLoading && loginMethod === "google" ? <CircularProgress sx={{ color: "black", marginInline: 'auto' }} size={'1.4rem'} /> : <Grid display={'flex'} gap={1} flexDirection={"row"} alignItems={'center'}>
              <img src={googleIcon} width={24} height={24} />
              <Typography variant="caption" sx={{ textTransform: "none", fontWeight: 500, fontSize: '1rem' }}>
                Login via Google
              </Typography>
            </Grid>}
          </WHITEBG>} */}
          {/* {config?.settings.googleLogin && <GoogleLogin userData={userData} setUserData={setUserData} signin={loginViaEmailAsync} loginMethod={loginMethod} setLoginMethod={setLoginMethod} isLoading={isLoading} />}
          {config?.settings.linkedInLogin && <LinkedinLogin userData={userData} setUserData={setUserData} signin={loginViaEmailAsync} loginMethod={loginMethod} setLoginMethod={setLoginMethod} isLoading={isLoading} />} */}
          {/* <Typography variant='bodyTextRegular' color={theme.palette.customColors.g100} marginTop={1} sx={{ textAlign: { xs: 'center', md: "center" }, marginBottom: { xs: "2rem", sm: 0 } }}>
            
            Are you a Startup? <BLUEBORDER
              component="label"
              role={undefined}
              tabIndex={-1}
              onClick={() => {
                redirectTo(currentIP)
              }}
              sx={{
                backgroundColor: 'transparent !important',
                border: "0",
                padding: "0"
              }}> Click here </BLUEBORDER>
          </Typography> */}
          {/* {config?.settings.appleLogin && <WHITEBG onClick={handleSignIn} data-border="true" data-type="sign in" sx={{
            border: `1px solid ${theme.palette.customColors.g75}`, height: '55px'
          }} fullWidth> {isLoading && loginMethod === "appleid" ? <CircularProgress sx={{ color: "black", marginInline: 'auto' }} size={'1.4rem'} /> : <Grid display={'flex'} gap={1} flexDirection={"row"} alignItems={'center'}> <img src={appleIcon} width={24} height={24} /> <Typography variant="caption" sx={{ textTransform: "none", fontWeight: 500, fontSize: '1rem' }}> Login via Apple ID </Typography> </Grid>} </WHITEBG>} */}

      </Box>
    </Box>
  )
};

export default AuthLogin